const VIRTUAL_LIST_CLASSES_PREFIX = "virtualList";

export const VIRTUAL_LIST_CLASSES = {
  virtualListContainer: `${VIRTUAL_LIST_CLASSES_PREFIX}-container`,
  virtaulListItem: `${VIRTUAL_LIST_CLASSES_PREFIX}-item`,
};
